import { useLanguage } from "@/contexts/LanguageContext";

/**
 * WCAG 2.2 — 2.4.1 Bypass Blocks
 * Visually hidden until it receives keyboard focus, then becomes a visible
 * top-left action that jumps focus and viewport to <main id="main-content">.
 */
const SkipToContent = () => {
  const { t } = useLanguage();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-4 focus:py-2 focus:rounded-md focus:bg-primary focus:text-primary-foreground focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      {t.a11y.skipToContent}
    </a>
  );
};

export default SkipToContent;
